import { createActionGroup, props } from '@ngrx/store';
import { CourseDto } from './course.dto';

export const CourseAPIActions = createActionGroup({
  source: 'Course API',
  events: {
    'Get Courses By Website Success': props<{ courses: CourseDto[] }>(),
    'Get Courses By Website Failure': props<{ error: Error }>(),
  },
});
